var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "block q-mt-sm q-mb-sm" },
        [
          _c("q-btn", {
            attrs: {
              push: "",
              color: "secondary",
              label: _vm.showDetails ? "Hide Details" : "Show Details",
              icon: "remove red eye"
            },
            on: {
              click: function($event) {
                _vm.showDetails = !_vm.showDetails
              }
            }
          })
        ],
        1
      ),
      _vm._l(_vm.serverData, function(model) {
        return _c(
          "q-card",
          {
            key: model.id,
            staticClass: "mdi-card q-ma-md",
            staticStyle: { width: "400px" },
            attrs: { inline: "" }
          },
          [
            _vm.imageField
              ? _c(
                  "q-card-media",
                  [
                    _c("grid-cell-image", {
                      attrs: {
                        col: _vm.imageField,
                        value: model[_vm.imageField.field]
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function(props) {
                              return _c(
                                "div",
                                {},
                                [
                                  _c(
                                    "q-parallax",
                                    {
                                      attrs: {
                                        src: props.src,
                                        height: 250,
                                        speed: 0.2
                                      }
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          attrs: { slot: "loading" },
                                          slot: "loading"
                                        },
                                        [_vm._v("Loading...")]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }
                          }
                        ],
                        null,
                        true
                      )
                    }),
                    _c(
                      "q-card-title",
                      { attrs: { slot: "overlay" }, slot: "overlay" },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(_vm._f("shvl")(model, _vm.titleFieldPath)) +
                            "\n          "
                        ),
                        _vm.subTitleFieldPath
                          ? _c(
                              "span",
                              { attrs: { slot: "subtitle" }, slot: "subtitle" },
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm._f("shvl")(
                                        model,
                                        _vm.subTitleFieldPath
                                      )
                                    ) +
                                    "\n          "
                                )
                              ]
                            )
                          : _vm._e()
                      ]
                    )
                  ],
                  1
                )
              : _c("q-card-title", { staticClass: "title relative-position" }, [
                  _c("span", [
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm._f("shvl")(model, _vm.titleFieldPath)) +
                        "\n        "
                    )
                  ])
                ]),
            _c(
              "q-card-main",
              [
                _c(
                  "q-collapsible",
                  { attrs: { label: "details", value: _vm.showDetails } },
                  [
                    _c(
                      "q-list",
                      { attrs: { "no-border": "" } },
                      _vm._l(_vm.cardFields, function(column) {
                        return _c(
                          "q-item",
                          { key: column.field, staticClass: "q-body-1" },
                          [
                            _c("q-item-side", { attrs: { color: "primary" } }, [
                              _vm._v(
                                "\n                " +
                                  _vm._s(column.label) +
                                  "\n              "
                              )
                            ]),
                            _c(
                              "q-item-main",
                              {
                                staticClass: "text-info",
                                attrs: { align: "left" }
                              },
                              [
                                _c(_vm._f("componentIs")(column), {
                                  tag: "component",
                                  staticClass: "text-info",
                                  attrs: {
                                    column: column,
                                    value: model[column.field],
                                    template: "raw",
                                    resource: _vm.resource,
                                    row: model,
                                    id: model.id
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      }),
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _c("q-card-separator"),
            _c(
              "q-card-actions",
              { attrs: { align: "between" } },
              [
                _c("q-btn", {
                  attrs: {
                    color: "primary",
                    flat: "",
                    label: "edit",
                    icon: "edit"
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push(
                        _vm.baseRoute + "/edit/" + model.id
                      )
                    }
                  }
                }),
                _c("q-btn", {
                  attrs: {
                    flat: "",
                    small: "",
                    color: "negative",
                    icon: "delete"
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleDelete(model.id)
                    }
                  }
                })
              ],
              1
            )
          ],
          1
        )
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }